export default "/signup/_next/static/chunks/fonts/lineto-circular-medium-5279335ef07c83acff512c89c0e37dc6.woff2";